import React, { useMemo } from 'react';
import { Button, CardFooter, Input } from 'reactstrap';
import { AFAS_SUBMIT_MODE_OPTIONS } from '../constants';

const resolveSubmitLabel = (submitMode, listMode, isSubmitting) => {
    if (isSubmitting) {
        return 'Bezig...';
    }
    if (submitMode === 'hand') {
        return listMode === 'hand'
            ? 'Afboeken als gereed'
            : 'Naar handmatige lijst';
    }
    if (submitMode === 'afmelden') {
        return 'Afmelden';
    }
    if (submitMode === 'auto') {
        return 'Verzenden naar AFAS';
    }
    return 'Verwerken';
};

const AfasFooterActions = ({
    submitMode = '',
    listMode = 'auto',
    onSubmitModeChange,
    onVerwerken,
    disabled = false,
    isSubmitting = false,
    showActions = true,
    /** Bluebox: when Question1 fails, Automatisch is disabled and Handmatig forced. */
    disableAutoSubmit = false,
    children = null,
}) => {
    const hasToolbar = Boolean(children);
    const submitLabel = useMemo(
        () => resolveSubmitLabel(submitMode, listMode, isSubmitting),
        [submitMode, listMode, isSubmitting],
    );

    return (
        <div className="chat-layout-footer verzoken-footer-height afas-footer-bar-height">
            <CardFooter className="d-flex align-items-center justify-content-between p-2 chat-layout-footer__inner afas-footer-bar">
                {hasToolbar && (
                    <div className="d-flex align-items-center flex-nowrap flex-grow-1 min-w-0 me-3 afas-footer-bar__toolbar">
                        {children}
                    </div>
                )}
                {showActions && (
                    <div className="d-flex align-items-center flex-nowrap gap-2 flex-shrink-0 afas-footer-bar__actions">
                        <div style={{ minWidth: '150px' }}>
                            <Input
                                type="select"
                                className="form-select form-select-sm"
                                value={submitMode}
                                onChange={(event) =>
                                    onSubmitModeChange?.(event.target.value)
                                }
                                aria-label="Verzendwijze"
                            >
                                <option value="">Verzendwijze</option>
                                {AFAS_SUBMIT_MODE_OPTIONS.map((option) => (
                                    <option
                                        key={option.value}
                                        value={option.value}
                                        disabled={
                                            disableAutoSubmit && option.value === 'auto'
                                        }
                                    >
                                        {option.label}
                                    </option>
                                ))}
                            </Input>
                        </div>

                        <Button
                            type="button"
                            color="primary"
                            outline
                            className="btn-outline-primary-blue btn-color-style footer--coordinator-planboard__btn ms-0"
                            onClick={onVerwerken}
                            disabled={disabled || !submitMode}
                        >
                            {submitLabel}
                        </Button>
                    </div>
                )}
            </CardFooter>
        </div>
    );
};

export default AfasFooterActions;